import React from "react";
import "./App.css";
import { Board } from "../Board/Board";

function App() {
  return (
    <div className="App">
      <Board />
    </div>
  );
}

export default App;
